<template>
    <li
        class="house-grid-item template4"
        :class="{ 'house-sold': soldDate }"
        :title="address"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
        @click="openDetail(link, $event)"
    >
        <article>
            <a
                :href="linkData.href"
                :target="linkData.target"
                :aria-label="linkData['aria-label']"
                :rel="linkData.rel"
                :self="linkData.self"
            >
                <img-swiper
                    @change="onPreviewChange"
                    :imgNotZoom="imgNotZoom"
                    class="house-preview"
                    :allImagesJson="previewsJson"
                    :alt="address"
                    :dir="dir"
                    :errorImg="defHouseImg"
                    :showSwitch="showSwitch && !isShowMask"
                >
                    <house-tag
                        v-if="exclusiveTag && isMobile && !isShowMask"
                        v-bind="exclusiveTag"
                        theme="v4"
                    />
                    <span v-if="tour3D" class="house-count">
                        <i class="iconfont icon-3d"></i>{{ $t('md-house.3d') }}</span>
                    <template v-else>
                        <span
                            v-if="picturesNum > 1"
                            class="house-count"
                            :class="{
                                hide: !isMobile || previews.length <= 1,
                                'hover-show': previews.length > 1
                            }"
                        >{{ previewIndex }}/{{ picturesNum }}</span>
                        <span
                            v-if="picturesNum > 1"
                            class="house-count"
                            :class="{
                                hide: isMobile && previews.length > 1,
                                'hover-hide': previews.length > 1
                            }"
                        >
                            <i class="iconfont icon-pic"></i>
                            {{ picturesNum }}
                        </span>
                    </template>
                    <span
                        v-if="!soldDate && !widget"
                        :class="[
                            'icon-fav',
                            collected ? 'collected' : '',
                            showCheckbox ? 'right-bottom' : ''
                        ]"
                        @click.stop.prevent="collect"
                    >
                        <i class="iconfont icon-heart-fill"></i>
                    </span>
                </img-swiper>
            </a>
            <div
                class="mask"
                v-if="!isMobile"
                :class="{ 'blur-price': isShowMask }"
            >
                <label v-if="showCheckbox" class="checkbox" @click.stop>
                    <input
                        type="checkbox"
                        v-model="checkValue"
                        @change="onChecked"
                    />
                    <span class="iconfont icon-checked-light"></span>
                </label>
                <div class="house-detail">
                    <house-tag
                        v-bind="exclusiveTag"
                        theme="v4"
                        v-if="exclusiveTag && !isShowMask"
                    />
                    <title-mask v-if="isShowMask" />
                    <template v-else-if="soldDate">
                        <only-client>
                            <p :class="['house-sold-date house-status',statusOrigin]">
                                <span v-if="showStar">{{ $t('md-house.soldOnWith', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                                <span v-else>{{ $t('md-house.soldOn', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                            </p>
                        </only-client>
                        <p class="sold-flag">
                            {{ statusOrigin || $t('md-house.sold') }}
                        </p>
                        <no-disclosure
                            v-if="!!house.nodisclosureDes || hidePrice"
                            :des="
                                hidePrice
                                    ? $t('md-house.nondisclosure')
                                    : house.nodisclosureDes
                            "
                        />
                        <template v-else>
                            <div
                                class="initial-price"
                                v-if="showAllPrice && initialPrice"
                            >
                                <p class="house-initial-price">
                                    {{ initialPrice.replace(/\s/g, '') }}
                                </p>
                                <span
                                    :class="[
                                        'house-trend',
                                        trendUp ? 'trend-up' : 'trend-down'
                                    ]"
                                    v-if="showAllPrice && trend"
                                >{{ trend }}</span>
                            </div>
                            <p class="house-price">
                                {{
                                    (showSoldPrice ? soldPrice : price).replace(
                                        /\s/g,
                                        ''
                                    )
                                }}
                            </p>
                        </template>
                    </template>
                    <template v-else>
                        <house-tag v-bind="tag" theme="v4" v-if="tag && !isShowMask" />
                        <p
                            class="house-price"
                            v-if="house.nodisclosureDes == null"
                        >
                            {{ price.replace(/\s/g, '') }}
                        </p>
                        <no-disclosure
                            v-else
                            :des="house.nodisclosureDes"
                        />
                    </template>
                    <div class="house-basic clearfix">
                        <span
                            class="vertical-line"
                            v-for="item in basic"
                            :key="item.key"
                        >{{ item.text }}</span>
                    </div>
                    <h3 class="house-address">
                        <a
                            :href="linkData.href"
                            :target="linkData.target"
                            :aria-label="linkData['aria-label']"
                            :rel="linkData.rel"
                            :self="linkData.self"
                        >{{ address }}</a>
                    </h3>
                    <div class="house-info-detail">
                        <p class="house-tag">
                            <!-- property types  Customers can customize the configuration ， not fixed ， Nor should it be internationalized  -->
                            <!-- {{ $t(`common:${propertyType}`) }} -->
                            {{ propertyType }}
                        </p>
                        <!-- mls number  Do not do internationalization  -->
                        <p v-if="showMls" class="house-mls-id">
                            MLS# {{ mlsid }}
                        </p>
                        <p v-if="!isShowMask" class="house-provided ws-pre-wrap">{{ provided }}</p>
                    </div>
                    <site-img
                        v-if="mlsLogo"
                        class="house-mls-logo"
                        :src="mlsLogo"
                        :alt="mlsAlt"
                        :size="30"
                        dir="height"
                    />
                    <div
                        :class="['house-footer', soldDate ? 'sold-footer' : '']"
                    >
                        <p class="read-more">
                            <a
                                :href="linkData.href"
                                :target="linkData.target"
                                :aria-label="linkData['aria-label']"
                                :rel="linkData.rel"
                                :self="linkData.self"
                            >{{ $t('md-house.readMore') }}</a>
                        </p>
                    </div>
                </div>
            </div>
            <house-mask v-if="isShowMask" />
            <div
                class="mask mobile-mask"
                v-if="isMobile"
                :class="{ 'blur-price': isShowMask }"
            >
                <div class="house-detail">
                    <title-mask v-if="isShowMask" />
                    <template v-else-if="soldDate">
                        <only-client>
                            <p :class="['house-sold-date house-status',statusOrigin]">
                                <span v-if="showStar">{{ $t('md-house.soldOnWith', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                                <span v-else>{{ $t('md-house.soldOn', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                            </p>
                        </only-client>
                        <p class="sold-flag">
                            {{ statusOrigin || $t('md-house.sold') }}
                        </p>
                        <no-disclosure
                            v-if="!!house.nodisclosureDes || hidePrice"
                            :des="
                                hidePrice
                                    ? $t('md-house.nondisclosure')
                                    : house.nodisclosureDes
                            "
                        />
                        <template v-else>
                            <div
                                class="initial-price"
                                v-if="showAllPrice && initialPrice"
                            >
                                <p class="house-initial-price">
                                    {{ initialPrice.replace(/\s/g, '') }}
                                </p>
                                <span
                                    :class="[
                                        'house-trend',
                                        trendUp ? 'trend-up' : 'trend-down'
                                    ]"
                                    v-if="showAllPrice && trend"
                                >{{ trend }}</span>
                            </div>
                            <p class="house-price">
                                {{
                                    (showSoldPrice ? soldPrice : price).replace(
                                        /\s/g,
                                        ''
                                    )
                                }}
                            </p>
                        </template>
                    </template>
                    <template v-else>
                        <house-tag theme="v4" v-if="tag && !isShowMask" v-bind="tag" />
                        <p
                            class="house-price"
                            v-if="house.nodisclosureDes == null"
                        >
                            {{ price.replace(/\s/g, '') }}
                        </p>
                        <no-disclosure
                            v-else
                            :des="house.nodisclosureDes"
                        />
                    </template>
                    <div class="house-basic clearfix">
                        <span
                            class="vertical-line"
                            v-for="item in basic"
                            :key="item.key"
                        >{{ item.text }}</span>
                    </div>
                    <h3 class="house-address">
                        <a
                            :href="linkData.href"
                            :target="linkData.target"
                            :aria-label="linkData['aria-label']"
                            :rel="linkData.rel"
                            :self="linkData.self"
                        >{{ address }}</a>
                    </h3>
                    <div class="house-info-detail">
                        <p class="house-tag">
                            <!-- property types  Customers can customize the configuration ， not fixed ， Nor should it be internationalized  -->
                            <!-- {{ $t(`common:${propertyType}`) }} -->
                            {{ propertyType }}
                        </p>
                        <p v-if="showMls" class="house-mls-id">
                            MLS# {{ mlsid }}
                        </p>
                        <p v-if="!isShowMask" class="house-provided ws-pre-wrap">{{ provided }}</p>
                    </div>
                    <site-img
                        v-if="mlsLogo"
                        class="house-mls-logo"
                        :src="mlsLogo"
                        :alt="mlsAlt"
                        :size="30"
                        dir="height"
                    />
                    <div
                        :class="['house-footer', soldDate ? 'sold-footer' : '']"
                    >
                        <p class="read-more">
                            <a
                                :href="linkData.href"
                                :target="linkData.target"
                                :aria-label="linkData['aria-label']"
                                :rel="linkData.rel"
                                :self="linkData.self"
                            >{{ $t('md-house.readMore') }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>

<script>
import Item from '../item';
import ItemForSearch from '../itemForSearch';
export default {
    emits: ['mouseenter', 'mouseleave'],
    mixins: [Item, ItemForSearch],
    data: function() {
        return {
            active: false
        };
    },
    methods: {
        onMouseEnter() {
            this.active = true;
            if (!this.checkValue) {
                this.$emit('mouseenter');
            }
        },
        onMouseLeave() {
            this.active = false;
            if (!this.checkValue) {
                this.$emit('mouseleave');
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.house-grid-item.template4 {
    --mask-bg-color: rgba(3, 10, 26, 0.85);
    --mask-text-color: #ffffff;
    position: relative;
    height: 420px;
    &:hover {
        .swiper-prev,
        .swiper-next {
            display: flex;
        }
        .mask {
            .house-detail{
                .house-footer {
                    display: block;
                }
                &::after{
                    display: block;
                }
            }
        }
    }
    > article {
        width: 100%;
        height: 100%;
    }
    .house-preview {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        @include media-min-800 {
            .img-content:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                background: linear-gradient(
                    180deg,
                    rgba(36, 42, 61, 0.0001) 0%,
                    rgba(36, 42, 61, 0.6) 100%,
                    #242a3d 100%
                );
            }
        }
        img[data-src] {
            width: 100%;
            height: 100%;
        }
        .slot-wraper > .house-count {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            color: white;
            // width: 43px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            display: flex;
            justify-content: center;
            background-color: #4a4a60;
            opacity: 0.8;
            padding: 0 2px;
            .iconfont {
                font-size: 12px;
                margin-right: 4px;
                position: relative;
            }
        }
        .house-count.hide {
            display: none;
        }
        &:hover .house-count {
            text-align: center;
            &.hover-show {
                display: block;
            }
            &.hover-hide {
                display: none;
            }
        }
        .house-status {
            position: absolute;
            left: 15px;
            top: 15px;
            z-index: 1;
        }
        .icon-fav {
            display: block;
            position: absolute;
            left: 20px;
            top: 20px;
            z-index: 1;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            color: #8195bd;
            .icon-heart-fill {
                font-size: 14px;
                color: #8195bd;
                cursor: pointer;
            }
            &.collected {
                .icon-heart-fill {
                    color: #ff5661;
                }
            }
        }
    }
    .mask {
        position: absolute;
        left: 0;
        z-index: var(--level-low);
        width: 100%;
        pointer-events: none;
        &.mobile-mask {
            margin-left: 0;
        }
        &.blur-price {
            .house-detail {
                z-index: var(--level-sublow);
            }
            position: static;
        }
        .checkbox {
            display: none;
            position: absolute;
            top: 14px;
            left: 20px;
            z-index: 2;
            text-align: center;
            border: 1px solid #ebecf1;
            box-shadow: var(--box-shadow);
            line-height: 16px;
            width: 18px;
            height: 18px;
            vertical-align: middle;
            font-size: 14px;
            @include color-theme();
            background-color: white;
            cursor: pointer;
            input {
                display: none;
                & + .iconfont {
                    display: none;
                }
            }
            input:checked + .iconfont {
                display: block;
                font-size: 14px;
                font-weight: bold;
                @include color-theme('background-color');
                color: white;
            }
        }
        .house-detail {
            position: absolute;
            bottom: 0;
            width: 100%;
            color: #fff;
            padding: 0px 20px 20px 20px;
            pointer-events: auto;
            &::after{
                content: "";
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background-image: linear-gradient(
                    to bottom,
                    rgba(8, 17, 38, 0),
                    rgba(8, 17, 38, 0.574)
                );
                z-index: -1;
                display: none;
            }
            .house-status {
                margin-top: 10px;
                &:first-child{
                    margin-right:5px;
                }
            }
            .nodisclosure {
                .dollar {
                    color: white;
                    font-size: 24px;
                }
                .secret {
                    font-size: 12px;
                    color: white;
                }
                .des {
                    color: #ff5661;
                    font-size: 12px;
                }
            }
            .house-sold-date {
                display: inline-block;
                line-height: 24px;
                height: 24px;
                width: auto;
                padding: 0 12px;
                margin-bottom: 12px;
                text-transform: capitalize;
                font-family: var(--font-medium);
                font-size: 12px;
                background-color: #8195bd;
                text-transform: none;
            }
            .house-price,
            .hide-price {
                margin-top: 10px;
                font-family: var(--font-title);
                font-size: 24px;
                height: 24px;
                line-height: 24px;
                color: #fff;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.3);
                cursor: pointer;
                .link {
                    color: var(--color-theme);
                    text-decoration: underline;
                    cursor: pointer;
                }
                &.hide-price {
                    font-size: 16px;
                }
            }
            .sold-flag {
                font-size: 12px;
                font-family: var(--font-bold);
                height: 18px;
                line-height: 18px;
                margin-bottom: 8px;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.3);
                text-transform: uppercase;
                display: none;
            }
            .house-basic {
                color: #fff;
                font-size: 14px;
                font-family: var(--font-bold);
                line-height: 20px;
                margin: 10px -15px 0 0;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.3);
                letter-spacing: 0.5px;
                > span {
                    > span:last-child {
                        font-size: 12px;
                    }
                }
                .vertical-line {
                    white-space: nowrap;
                }
                .vertical-line:after {
                    content: '·';
                    display: inline;
                    margin: 0 4px;
                }
                .vertical-line:nth-last-child(1):after {
                    content: '';
                }
            }
            .house-address {
                font-size: 12px;
                font-family: var(--font-normal);
                font-weight: 400;
                line-height: 14px;
                height: 14px;
                width: 100%;
                margin: 6px 0 0 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.3);
            }

            .house-tag,
            .house-provided,
            .house-mls-id {
                font-family: var(--font-normal);
                line-height: 14px;
                font-size: 12px;
                margin-top: 6px;
                color: #fff;
                opacity: 0.7;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.3);
            }
            .house-provided {
                font-size: 14px;
            }
            .house-provided,
            .house-mls-id {
                font-style: italic;
                margin-top: 12px;
            }
            .house-mls-id {
                & + .house-provided {
                    margin-top: 0;
                }
            }
            .house-mls-logo {
                position: relative;
                margin-top: 10px;
                height: 20px;
                width: auto;
                overflow: hidden;
            }
            .house-footer {
                display: none;
                .read-more {
                    height: 32px;
                    width: 132px;
                    line-height: 28px;
                    margin-top: 24px;
                    text-align: center;
                    border: solid 2px #fff;
                    font-family: var(--font-normal);
                    font-size: 13px;
                    letter-spacing: 2px;
                }

                &.house-show-mls {
                    .house-tag,
                    .house-provided,
                    .house-mls-id {
                        color: white;
                        opacity: 0.7;
                    }
                    display: block;
                    .read-more {
                        display: none;
                    }
                }
            }
        }
        &:not(.blur-price) .house-detail .initial-price {
            /* display: none; */
            margin-bottom: 10px;
            height: 16px;
            .house-trend {
                height: 16px;
                line-height: normal;
                font-size: 14px;
                font-family: var(--font-bold);
                margin-left: 8px;
                &:before {
                    margin-top: 3px;
                    margin-right: 4px;
                    vertical-align: top;
                    content: '';
                    display: inline-block;
                    width: 0;
                    height: 0;
                    border-left: solid 5px transparent;
                    border-right: solid 5px transparent;
                    border-bottom: solid 6px #29cb97;
                }
                &.trend-up {
                    color: #29cb97;
                }
                &.trend-down {
                    color: #ff5661;
                    &:before {
                        border-top: solid 6px #ff5661;
                        border-bottom: none;
                    }
                }
            }

            .house-initial-price {
                display: inline-block;
                color: #8195bd;
                line-height: 1;
                font-family: var(--font-title);
                font-size: 16px;
                text-decoration: line-through;
            }
        }
    }
    .md-house__mask {
        .mask-box {
            position: absolute;
            top: 30%;
        }
    }

    @include media-min-600 {
        &:hover {
            .mask {
                .house-basic.clearfix,
                .house-info-detail > .house-tag,
                .house-detail > .sold-flag {
                    display: none;
                }
            }
            .mask .checkbox {
                display: block;
            }
            .house-preview .icon-fav {
                z-index: 3;
            }
        }
        .house-preview {
            .icon-fav.right-bottom {
                right: 20px;
                bottom: 26px;
                left: auto;
                top: auto;
            }
        }
    }
    @include media-600 {
        height: auto;
        .house-preview {
            //margin-top: -1px; // Remove the weird white border
            height: 64vw;
            .icon-fav {
                display: block;
                right: 16px;
                bottom: 16px;
                top: unset;
                left: unset;
            }
        }
        .mask {
            z-index: var(--level-low);
            margin-top: -1px;
            position: relative;
            left: 0;
            width: 100%;
            background-color: #242a3d;
            .house-detail {
                padding: 15px;
                position: relative;
                background-image: none;
                .house-status {
                    margin-top: 0;
                }
                .sold-flag {
                    display: none;
                }
                .house-sold-date {
                    display: inline-block;
                    margin-bottom: 14px;
                    padding: 0 6px;
                    height: 20px;
                    line-height: 20px;
                    height: 24px;
                    line-height: 24px;
                    margin-bottom: 12px;
                }
                .house-basic {
                    margin-top: 6px;
                }
                .house-address {
                    margin-top: 2px;
                }
                .initial-price {
                    display: block;
                }
                .house-footer {
                    display: block;
                    .house-provided,
                    .house-mls-id {
                        width: 100%;
                        max-width: calc(100% - 85px);
                        margin-top: 4px;
                        &.no-mls {
                            max-width: 100%;
                        }
                        br {
                            display: none;
                        }
                    }
                    .house-mls-id {
                        height: 14px;
                        @include ellipsis();
                    }
                    .house-tag,
                    .house-provided,
                    .house-mls-id {
                        color: #bfc9e4;
                    }
                    .read-more {
                        display: none;
                    }
                    .house-mls-logo {
                        position: absolute;
                        max-width: 80px;
                        height: 24px;
                        right: 15px;
                        bottom: 15px;
                        object-fit: contain;
                    }
                }
            }
        }
    }
}
</style>
